// extracted by mini-css-extract-plugin
export default {"root":"StaticQuizEndScreen-module-root-bj8vW","textContainer":"StaticQuizEndScreen-module-textContainer-NfuCp"};